<div class="col-md-8 text-center d-flex mx-auto  align-items-center">
  <span class="footer-compare-box">
    <span class="add-icon">
      <div [ngStyle]="{'width': !companyoneDetails?.companylogo && compareCompanyFirst?.value != 'Add Company' ? '20px' :'' }">
      <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!companyoneDetails?.companylogo && compareCompanyFirst?.value != 'Add Company'"></i>
      </div>
      <img [src]="companyoneDetails?.companylogo" alt="companyoneDetails?.name" *ngIf="companyoneDetails?.companylogo" style="width: 20px; height: auto;">
      <div [ngStyle]="{'width': compareCompanyFirst?.value == 'Add Company' ? '20px' :'' }">
      <i class="fa-regular fa-circle-plus f-16" *ngIf="compareCompanyFirst?.value == 'Add Company'"> </i>
      </div>
    </span>
    <input data-testid="auto-app-webbtree-comapnylist-footer-input-1" type="text" [formControl]="compareCompanyFirst" disabled>
    <i class="far fa-times f-16 pointer" (click)="clearCompanyName('companyone')" *ngIf="compareCompanyFirst?.value != 'Add Company'"> </i>

  </span>
  <span class="footer-compare-box">
    <span class="add-icon">
      <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!companytwoDetails?.companylogo && compareCompanySecond?.value != 'Add Company'"></i>
      <img [src]="companytwoDetails?.companylogo" alt="companytwoDetails?.name" *ngIf="companytwoDetails?.companylogo" style="width: 20px; height: auto;">
        <div [ngStyle]="{'width': compareCompanySecond?.value == 'Add Company' ? '20px' :'' }">
      <i class="fa-regular fa-circle-plus f-16" *ngIf="compareCompanySecond?.value == 'Add Company'"> </i>
      </div>
    </span>
    <input data-testid="auto-app-webbtree-comapnylist-footer-input-2" type="text" [formControl]="compareCompanySecond" disabled>
    <i class="far fa-times f-16 pointer" (click)="clearCompanyName('companytwo')" *ngIf="compareCompanySecond?.value != 'Add Company'"> </i>

  </span>
<button data-testid="auto-app-webbtree-comapnylist-footer-button-1"  class="disabled-button" style="width: 220px; border-radius: .3125rem;" [ngClass]="{'enabled-button': compareCompanyFirst.value != 'Add Company' && compareCompanySecond.value != 'Add Company'}" (click)="redirectTOCompanyCompare()">
  Compare
</button>
</div>
